import { basicAuth, oauthAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

const keywords =
  "harvest ats applicant tracking candidates jobs recruiting hiring interviews";
const defaultUrlPattern = () => "https://harvest\\.greenhouse\\.io/.*";

export const greenhouse = defineProduct({
  name: "Greenhouse",
  tagLine: "Hiring and recruiting software",
  logo,
  tags: ["productivity"],
  variants: [
    productVariant({
      identifier: "greenhouseV3",
      authLabel: "Harvest v3 OAuth",
      keywords,
      protocol: "http",
      defaultUrlPattern,
      auth: oauthAuth,
      steps: [
        {
          title: "Create Harvest v3 credentials",
          items: [
            {
              kind: "markdown",
              content:
                "In Greenhouse, go to **Configure > Dev Center > API Credential Management**, create **Harvest v3 (OAuth)** credentials, and grant the scopes your workflows need.",
            },
          ],
        },
        {
          title: "Enter your client credentials",
          items: [
            {
              kind: "input",
              label: "Client key",
              required: true,
              target: { kind: "oauthConnection", field: "clientId" },
            },
            {
              kind: "input",
              label: "Client secret",
              required: true,
              target: { kind: "oauthConnection", field: "clientSecret" },
            },
          ],
        },
      ],
      oauth: {
        grantType: () => "client_credentials",
        tokenEndpoint: () => "https://auth.greenhouse.io/token",
        tokenEndpointAuthMethod: () => "client_secret_basic",
        clientCredentialsFrom: "db",
        scopes: () => [],
      },
      connectionTest: {
        protocol: "http",
        request: () => ({
          url: "https://harvest.greenhouse.io/v3/users?per_page=1",
          expectedStatus: [200, 403],
        }),
      },
      usageHint: () =>
        "Use the Harvest API v3 endpoints (https://harvest.greenhouse.io/v3/…).",
    }),
    productVariant({
      identifier: "greenhouse",
      authLabel: "Harvest v1/v2 API key (deprecated)",
      keywords,
      protocol: "http",
      defaultUrlPattern,
      auth: (app) =>
        basicAuth({
          username: app.secret.apiKey,
          password: "",
        }),
      steps: [
        {
          title: "Get your Greenhouse API key",
          items: [
            {
              kind: "markdown",
              content:
                "Log in to Greenhouse and navigate to **Configure > Dev Center > API Credential Management** to create a Harvest API key.",
            },
          ],
        },
        {
          title: "Enter your API key",
          items: [
            {
              kind: "input",
              label: "Harvest API key",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://harvest.greenhouse.io/v1/users",
      },
      publicEnvVars: () => ({
        GREENHOUSE_API_KEY: "{will-be-injected}",
      }),
      usageHint: () =>
        "This connector uses the deprecated Harvest v1/v2 API. Create a Harvest v3 OAuth connector and migrate your workflow before Greenhouse retires v1 and v2.",
    }),
  ],
});
